import { render } from "./Example.vue?vue&type=template&id=69070706&scoped=true"
import script from "./Example.vue?vue&type=script&lang=ts"
export * from "./Example.vue?vue&type=script&lang=ts"

import "./Example.vue?vue&type=style&index=0&id=69070706&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-69070706"

export default script